import React from 'react';
import './css/contact-container.css';
import ContactFormSection from './contact-form-section';

export default function ContactContainer() {
	return (
		<main className="contact-page" id="contact">
			<section className="contact-page__grid">
				<div className="contact-card contact-card--info">
					<section className="contact-block">
						<h2>Contact Information</h2>
						<div className="contact-detail-list">
							<div className="contact-detail-item">
								<div className="contact-detail-item__icon" aria-hidden="true">
									<svg viewBox="0 0 24 24" focusable="false">
										<path d="M19.05 4.94A9.8 9.8 0 0 0 12.06 2c-5.45 0-9.88 4.43-9.88 9.88 0 1.74.45 3.44 1.31 4.95L2 22l5.32-1.39a9.84 9.84 0 0 0 4.74 1.21h.01c5.45 0 9.88-4.43 9.88-9.88 0-2.64-1.03-5.11-2.9-7zM12.07 20.15h-.01a8.2 8.2 0 0 1-4.18-1.14l-.3-.18-3.16.83.84-3.08-.2-.32a8.18 8.18 0 0 1-1.26-4.38c0-4.52 3.68-8.2 8.21-8.2 2.19 0 4.25.85 5.8 2.4a8.15 8.15 0 0 1 2.4 5.8c0 4.53-3.68 8.21-8.2 8.21zm4.5-6.15c-.25-.12-1.47-.73-1.7-.81-.23-.09-.4-.12-.57.12-.17.24-.65.8-.8.96-.15.17-.29.18-.54.06a6.67 6.67 0 0 1-1.96-1.21 7.36 7.36 0 0 1-1.36-1.69c-.14-.24-.01-.37.11-.49.11-.11.24-.29.36-.43.12-.14.16-.24.24-.4.08-.17.04-.31-.02-.43-.06-.12-.57-1.37-.78-1.88-.21-.5-.42-.43-.57-.44h-.49c-.17 0-.43.06-.65.31-.22.24-.85.83-.85 2.02s.87 2.34.99 2.5c.12.17 1.7 2.6 4.11 3.64.57.25 1.02.39 1.37.49.58.18 1.11.15 1.53.09.47-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.1-.23-.15-.48-.28z" fill="currentColor" />
									</svg>
								</div>
								<div className="contact-detail-item__content">
									<p>
										<a href="https://wa.me/94773876580" target="_blank" rel="noreferrer" aria-label="Message TaxObey on WhatsApp at +94 773 876 580">+94 773 876 580</a>
									</p>
									<p>
										<a href="https://wa.me/94707876580" target="_blank" rel="noreferrer" aria-label="Message TaxObey on WhatsApp at +94 707 876 580">+94 707 876 580</a>
									</p>
								</div>
							</div>
							<div className="contact-detail-item">
								<div className="contact-detail-item__icon" aria-hidden="true">
									<svg viewBox="0 0 24 24" focusable="false">
										<path d="M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm0 2v.01L12 12l8-4.99V7H4zm16 10V9.23l-7.47 4.67a1 1 0 0 1-1.06 0L4 9.23V17h16z" fill="currentColor" />
									</svg>
								</div>
								<p>
									<a href="mailto:info@taxobey.lk" aria-label="Email TaxObey at info@taxobey.lk">info@taxobey.lk</a>
								</p>
							</div>
							<div className="contact-detail-item">
								<div className="contact-detail-item__icon" aria-hidden="true">
									<svg viewBox="0 0 24 24" focusable="false">
										<path d="M12 2a7 7 0 0 1 7 7c0 4.77-5.03 10.62-6.09 11.81a1.2 1.2 0 0 1-1.82 0C10.03 19.62 5 13.77 5 9a7 7 0 0 1 7-7zm0 9.5A2.5 2.5 0 1 0 12 6.5a2.5 2.5 0 0 0 0 5z" fill="currentColor" />
									</svg>
								</div>
								<p>
									<a href="https://maps.google.com/" aria-label="View TaxObey location on Google Maps">View on Google Maps</a>
								</p>
							</div>
						</div>
					</section>

					<section className="contact-block">
						<h2>Business Hours</h2>
						<div className="contact-hours-list">
							<p>Monday - Friday: 9:00 AM - 6:00 PM</p>
							<p>Saturday: 10:00 AM - 4:00 PM</p>
							<p>Sunday: Closed</p>
						</div>
					</section>
				</div>

				<ContactFormSection title="Send us a Message" />
			</section>
		</main>
	);
}
